import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MBFLogo from '../../utilities/dummy_assets/MBF_Logo.png';
import MapITLogo from '../../utilities/dummy_assets/mapITlogo.png';
// import backgroundImg from '../../assets/Background_Image.png';
import background from '../../utilities/dummy_assets/background.png';
// import StudentPasswordAPIs from '../../utilities/api/StudentPasswordAPIs';
import mail from '../../utilities/dummy_assets/mail.gif';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import { toast } from 'react-toastify';
import UserRequestAPIs from '../../utilities/api/user/AdminUserRequestList';
import Logos from '../../components/logos';

const CheckStatus = () => {
  const [step, setStep] = useState('intro'); // intro | form | status
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // accepted | declined | pending
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [timer, setTimer] = useState(60); // Timer starts at 60 seconds
  const [isTimerActive, setIsTimerActive] = useState(true); // Controls if timer is running

  const navigate = useNavigate();
  const location = useLocation();
  //   const { registrationData } = useSelector((state) => state.registration);
  const registrationData = location.state?.registrationData;

  // Log registration data only when it changes
  useEffect(() => {
    console.log('registrationData', registrationData);
    console.log('location.state', location.state);
  }, [registrationData, location.state]);
  // Handle browser back button - only allow going to login
  useEffect(() => {
    const handlePopState = event => {
      event.preventDefault();
      navigate('/studentlogin', { replace: true });
    };

    // Add event listener for browser back button
    window.addEventListener('popstate', handlePopState);

    // Push current state to prevent immediate back
    window.history.pushState(null, '', window.location.pathname);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  // Timer countdown effect
  useEffect(() => {
    let interval;

    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer(prevTimer => {
          if (prevTimer <= 1) {
            setIsTimerActive(false); // Stop timer when it reaches 0
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000); // Update every second
    }

    return () => clearInterval(interval); // Cleanup on unmount
  }, [isTimerActive, timer]);

  // Format timer to show minutes:seconds
  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Handle resend email button click
  const handleResendEmail = async () => {
    try {
      // Call the resend password API with email
      //   const response = await StudentPasswordAPIs.ResendPassword({ email: registrationData?.email });

      //   console.log('Resend email response:', response);
      //   console.log('Response status:', response?.status);
      //   console.log('Response data:', response?.data);
      const response = {
        status: 200,
        data: {
          status: 200,
          message: 'Email sent successfully',
        },
      };
      // Check for success - handle multiple response formats
      const isSuccess =
        response &&
        (response.status === 200 ||
          response.status === 'success' ||
          (response.data && response.data.status === 200) ||
          (response.data && response.data.status === 'success') ||
          response.statusText === 'OK' ||
          (response.message &&
            response.message.includes('sent to your email')) ||
          (response.data &&
            response.data.message &&
            response.data.message.includes('sent to your email')));

      if (isSuccess) {
        toast.success('Email sent successfully!');

        // Restart the timer after successful API call
        setTimer(60);
        setIsTimerActive(true);
      } else {
        console.log('API call failed - showing error');
        toast.error('Failed to send email. Please try again.');
      }
    } catch (error) {
      console.error('Error resending email:', error);
      console.error('Error details:', error.response || error.message);
      toast.error('Failed to send email. Please try again.');
    }
  };

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return 'Email is required';
    if (!emailRegex.test(email)) return 'Please enter a valid email address';
    return '';
  };

  const handleStatusCheck = async () => {
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await UserRequestAPIs.StatusCheck(email);
      console.log('response', response);
      // This would be your actual API call
      // const response = await api.checkStatus({ email });

      // For demo, we'll use a simple check based on email domain

      const status = response?.status;
      //   if (email.endsWith('@accepted.com')) {
      //     status = 'accepted';
      //   } else if (email.endsWith('@declined.com')) {
      //     status = 'declined';
      //   } else {
      //     status = 'pending';
      //   }

      setStatus(status);
      setStep('status');
    } catch (err) {
      setError('Failed to check status. Please try again.');
      console.error('Status check error:', err);
    } finally {
      setLoading(false);
    }
  };

  const renderStatusMessage = () => {
    let message = '';
    let background = '';
    let borderColor = '';
    let textColor = '';
    let icon = null;

    if (status === 'accepted') {
      message = 'Your request is accepted! Please Login into your account.';
      background = '#E8FFF3';
      borderColor = '#388E3C';
      textColor = '#388E3C';
    } else if (status === 'declined') {
      message = 'Your request has been declined. Try again later!';
      background = '#FFE6E6';
      borderColor = '#D32F2F';
      textColor = '#D32F2F';
    } else {
      message = 'Your request is not approved yet! Please wait for a while.';
      background = '#FEFFE0';
      borderColor = '#BC7700';
      textColor = '#BC7700';

      // Only for pending status
      icon = (
        <Box
          sx={{ width: '24px', height: '24px' }}
          dangerouslySetInnerHTML={{
            __html: `
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.001 11C11.001 10.4477 11.4487 10 12.001 10C12.5533 10 13.001 10.4477 13.001 11V14C13.001 14.5523 12.5533 15 12.001 15C11.4487 15 11.001 14.5523 11.001 14V11ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z" fill="#BC7700"/>
              <path d="M13.7689 4.19872C13.4209 3.54372 12.7429 3.13672 12.0009 3.13672C11.2589 3.13672 10.5809 3.54372 10.2329 4.19972L2.89493 18.0627C2.73209 18.3671 2.65143 18.7088 2.6609 19.0539C2.67037 19.399 2.76964 19.7357 2.94893 20.0307C3.12562 20.3271 3.37657 20.5723 3.67697 20.742C3.97738 20.9118 4.31687 21.0003 4.66193 20.9987H19.3399C20.0479 20.9987 20.6889 20.6367 21.0539 20.0307C21.2329 19.7356 21.332 19.3989 21.3415 19.0539C21.351 18.7088 21.2705 18.3672 21.1079 18.0627L13.7689 4.19872ZM4.66193 18.9987L12.0009 5.13572L19.3449 18.9987H4.66193Z" fill="#BC7700"/>
              </svg>
            `,
          }}
        />
      );
    }

    return (
      <>
        <Box
          sx={{
            fontFamily: 'Roboto',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            maxWidth: '412px',
            background,
            padding: '12px 16px',
            borderLeft: `4px solid ${borderColor}`,
            borderRadius: '8px',
            fontFamily: 'Roboto',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: textColor,
              fontSize: '16px',
            }}
          >
            {icon}
            <Typography sx={{ color: textColor }}>{message}</Typography>
          </Box>
        </Box>

        <Button
          fullWidth
          variant="outlined"
          sx={{
            fontFamily: 'Roboto',
            borderRadius: '12px',
            textTransform: 'none',
            height: '44px',
            width: '412px',
            mt: 3,
          }}
          onClick={() => {
            if (status === 'accepted') {
              navigate('/login');
            } else {
              setStep('intro');
              setEmail('');
            }
          }}
        >
          {status === 'accepted' ? 'Request Credentials' : 'Done'}
        </Button>
      </>
    );
  };

  return (
    <Box
      sx={{
        // // width: "100vw",
        // minHeight: "100vh",
        // overflow: "hidden",
        // display: "flex",
        // // justifyContent: "center",
        // // alignItems: "center",
        // backgroundImage: { sm: `url(${background})` },
        // backgroundSize: "cover",
        // backgroundPosition: "center",
        // position: "relative",
        // padding: "1rem",
        // boxSizing: "border-box",
        // flexDirection: "column",
        // justifyContent: "space-between"
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        flexGrow: 1,
        backgroundColor: { xs: 'white', sm: '#F7F7F7' },
        backgroundImage: { xs: 'none', sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Top right student site link */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          p: '16px 24px',
        }}
      >
        <span
          onClick={() =>
            (window.location.href = 'https://tinkerspace.mis.mapit.ai/login')
          }
          style={{
            color: 'var(--Accent-Accent-01, #0062CC)',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Go to Student Site
        </span>
      </Box>

      {/* Main Card */}
      <Box
        sx={{
          fontFamily: 'Roboto',
          background: '#fff',
          // backgroundColor: "yellow",
          padding: '1.5rem',
          borderRadius: '24px',
          // paddingX: '10px',
          // width: '460px',
          minHeight:
            step === 'intro' ? '328px' : step === 'form' ? '260px' : '236px',
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'translate(-50%, -50%)',
          boxShadow: { sm: '4px 4px 20px rgba(0, 123, 255, 0.1)' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '5px',
          margin: 'auto',
        }}
      >
        {step === 'intro' && (
          <>
            <img
              src={mail}
              alt="Email Animation"
              style={{ width: 140, height: 140 }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                // gap: '8px',
                padding: '24px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#212121',
                }}
              >
                Check Your Email
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '16px',
                  color: '#5C5C5C',
                  textAlign: 'center',
                }}
              >
                Check your email at {registrationData?.email || 'your email'}{' '}
                for login link. Didn't get it ? Click the button below
              </Typography>
            </Box>
            <Button
              onClick={() => setStep('form')}
              sx={{
                fontFamily: 'Roboto',
                borderRadius: '12px',
                width: '90%',
                height: '44px',
                // marginX: '24px',
                textTransform: 'none',
                color: '#007BFF',
                border: '2px solid #007BFF',
                backgroundColor: 'transparent',
                mt: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 123, 255, 0.04)',
                  border: '2px solid #0056B3',
                  color: '#0056B3',
                },
              }}
            >
              See the status
            </Button>
            {/* <Button
              variant="outlined"
              onClick={isTimerActive ? () => setStep('form') : handleResendEmail}
              disabled={isTimerActive}
              sx={{
                fontFamily: 'Roboto',
                borderRadius: '12px',
                width: '412px',
                height: '44px',
                textTransform: 'none',
                border: isTimerActive ? '2px solid #E0E0E0' : '2px solid #007BFF',
                color: isTimerActive ? '#9E9E9E' : '#007BFF',
                backgroundColor: isTimerActive ? '#F5F5F5' : 'transparent',
                cursor: isTimerActive ? 'not-allowed' : 'pointer',
                '&:hover': {
                  border: isTimerActive ? '2px solid #E0E0E0' : '2px solid #0056B3',
                  backgroundColor: isTimerActive ? '#F5F5F5' : 'rgba(0, 123, 255, 0.04)',
                },
                '&.Mui-disabled': {
                  border: '2px solid #E0E0E0',
                  color: '#9E9E9E',
                  backgroundColor: '#F5F5F5',
                },
              }}
            >
              {isTimerActive ? `Resend email in ${formatTime(timer)}` : 'Resend email'}
            </Button> */}

            {/* Navigate to Login Button */}
            <Button
              variant="contained"
              onClick={() => navigate('/studentlogin', { replace: true })}
              sx={{
                fontFamily: 'Roboto',
                borderRadius: '12px',
                width: '90%',
                height: '44px',
                textTransform: 'none',
                backgroundColor: '#007BFF',
                color: '#fff',
                mt: 1,
                '&:hover': {
                  backgroundColor: '#0056B3',
                },
              }}
            >
              Go to Login
            </Button>
          </>
        )}

        {step === 'form' && (
          <>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '24px',
                fontWeight: 600,
                color: '#212121',
                mb: '20px',
              }}
            >
              Check The Status
            </Typography>
            <Box
              sx={{
                width: '400px',
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '20px',
                  fontWeight: 500,
                  color: '#5C5C5C',
                  flex: 1,
                  // mb: '20px',
                  textAlign: 'left',
                  width: '90%',
                }}
              >
                Email Address
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your email"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                  if (error) setError('');
                }}
                error={!!error}
                helperText={error}
                onKeyPress={e => e.key === 'Enter' && handleStatusCheck()}
                sx={{
                  backgroundColor: '#fff',
                  border: `1px solid ${error ? '#D32F2F' : '#B5B5B5'}`,
                  borderRadius: '12px',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: 'none',
                    },
                  },
                  input: {
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    color: '#212121',
                    padding: '16px',
                    '&::placeholder': {
                      color: '#9E9E9E',
                      opacity: 1,
                    },
                  },
                  width: '90%',
                  flex: 1,
                }}
              />
            </Box>
            <Button
              variant="contained"
              onClick={handleStatusCheck}
              disabled={loading}
              sx={{
                borderRadius: '12px',
                width: '90%',
                // height: '44px',
                mt: '15px',
                textTransform: 'none',
                backgroundColor: '#007BFF',
                flex: 1,
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#0056B3',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#B5B5B5',
                  color: '#fff',
                },
              }}
            >
              {loading ? 'Checking...' : 'Check Status'}
            </Button>
          </>
        )}

        {step === 'status' && (
          <>
            <Typography
              sx={{
                padding: '24px',
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontStyle: 'normal',
                fontSize: '24px',
                lineHeight: '32px',
                letterSpacing: '0%',
                textAlign: 'center',
                width: '90%',
              }}
            >
              Check The Status
            </Typography>
            {renderStatusMessage()}
          </>
        )}
        <Button onClick={() => navigate('/login')}>close</Button>
      </Box>

      {/* Footer */}
      <Logos />
    </Box>
  );
};

export default CheckStatus;
